import React, { useState, useEffect } from 'react'
import './style.scss'


import { ContainerCad } from './../../components/Container'
import { Input, ValidacaoYup } from './../../components/Form'

import { TwitterPicker } from 'react-color'

function Situacao() {

    const [color, setColor] = useState('#FFFFFF')

    const validaCampos = {
        descricao: ValidacaoYup.string().required()
    }

    function onSaveBefore(data) {

        if (color === '') {
            return {
                error: true,
                message: 'Preencha a cor para continuar'
            }
        }

        data.cor = color.hex
        return data
    }

    function onEditarAfter(data, setData, setLoad, showModal) {

        setColor(data.cor)

        setData(data)
        setLoad(false)
        showModal(true)
    }

    function onStackData(data) {
        return data.map(item => {
            const descricao = item.dados[0];
            const cor = item.dados[1];
            let criado_por_raw = item.dados[2];
            let avatar_raw = item.dados[3];

            const firstName = criado_por_raw ? criado_por_raw.split(' ')[0] : '';
            let criadoPorHtml = '';

            if (avatar_raw && (avatar_raw.includes('http') || avatar_raw.includes('data:image'))) {
                criadoPorHtml = `
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <img src="${avatar_raw}" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;" />
                        <span style="color: var(--color-text-primary); font-size: 13px;">${firstName}</span>
                    </div>
                `;
            } else {
                criadoPorHtml = `
                    <div style="display: flex; align-items: center; gap: 8px;">
                         <div style="width: 24px; height: 24px; border-radius: 50%; background-color: #eee; display: flex; align-items: center; justify-content: center; font-size: 10px;">${firstName.charAt(0)}</div>
                        <span style="color: var(--color-text-primary); font-size: 13px;">${firstName}</span>
                    </div>
                `;
            }

            return {
                ...item,
                dados: [descricao, cor, criadoPorHtml]
            };
        })
    }

    return (
        <ContainerCad
            title='Situação Licença'
            titlesub='Cadastro / Situação'
            router='situacao'
            onStackData={onStackData}
            thead={[
                { nome: 'Descrição' },
                { nome: 'Cor', tamanho: 150 },
                { nome: 'Criado por', tamanho: 150 },
            ]}
            validacao={validaCampos}
            onSaveBefore={onSaveBefore}
            onEditarAfter={onEditarAfter}
            emptyStateText="Nenhuma situação cadastrada"
        >

            <div className="row">
                <Input name='descricao' titulo='Descrição' placeholder='Digite a descrição' col='col-lg-12' />
            </div>

            <div className="row situacao-color-picker" style={{ marginLeft: 6, marginTop: 8, display: 'flex', flexDirection: 'column' }}>
                <label>Cor da Situação</label>
                <TwitterPicker
                    triangle='hide'
                    color={color}
                    onChangeComplete={color => setColor(color)}
                />
            </div>

        </ContainerCad>
    )
}

export default Situacao